import React from "react";
import { connect, useDispatch } from "react-redux";
import { bool } from "prop-types";
import { ResponsiveHeader } from "pages/_components/header";
import Button from "pages/_components/Button";
import { goBack } from "connected-react-router";
import MainContainer from "pages/_components/MainContainer";
import { selectors as onboardingSelectors, actions as onboardingActions } from "reducers/onboarding";

import * as i18nUtils from "util/i18n";

const TermsAndConditionsLastStep = ({ isMobile }) => {
    const dispatch = useDispatch();

    const handleAcceptTermsAndConditions = (isSelected) => {
        dispatch(onboardingActions.acceptTermsAndConditionsPF(isSelected));
        dispatch(goBack());
    };

    return (
        <>
            {isMobile && <ResponsiveHeader ticket id="onboarding.vu.terms.and.conditions.label" />}
            {isMobile && (
                <MainContainer>
                    <div>
                        <p>{i18nUtils.get("onboarding.vu.terms.and.conditions.text.pdf")}</p>
                    </div>
                    <div className="form-actions">
                        <Button
                            label="global.accept"
                            bsStyle="primary"
                            onClick={() => {
                                handleAcceptTermsAndConditions(true);
                            }}
                            block
                        />
                        <Button
                            label="global.cancel"
                            bsStyle="outline"
                            onClick={() => {
                                handleAcceptTermsAndConditions(false);
                            }}
                            block
                        />
                    </div>
                </MainContainer>
            )}
        </>
    );
};

TermsAndConditionsLastStep.propTypes = {
    isMobile: bool.isRequired,
};

TermsAndConditionsLastStep.defaultProps = {};

const mapStateToProps = (state) => ({
    fetching: onboardingSelectors.getFetching(state),
});

export default connect(mapStateToProps)(TermsAndConditionsLastStep);
